import { Notifications } from '@mui/icons-material';
import NotificationList from './NotificationList';
import NotificationShow from './NotificationShow';
import NotificationCreate from './NotificationCreate';
import NotificationEdit from './NotificationEdit';

const resource = {
  list: NotificationList,
  show: NotificationShow,
  create: NotificationCreate,
  edit: NotificationEdit,
  icon: Notifications,
};

export default resource; 